(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["runway-lookbook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('runway-lookbook')) {
    customElements.define(
      'runway-lookbook',
      class RunwayLookbook extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-runway-track]');
          if (!this.track) return;
          this.looks = Array.from(this.track.querySelectorAll('[data-runway-look]'));
          this.currentEl = this.querySelector('[data-runway-current]');
          this.prevBtn = this.querySelector('[data-runway-prev]');
          this.nextBtn = this.querySelector('[data-runway-next]');
          this.index = 0;
          this.hovered = null;
          this.mqMobile = window.matchMedia('(max-width: 749px)');
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

          this.handleScroll = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.update();
            });
          };
          this.handleResize = () => {
            this.setOffsets();
            this.handleScroll();
          };
          this.handleBlockSelect = (event) => {
            const look = event.target.closest && event.target.closest('[data-runway-look]');
            if (!look || !this.contains(look)) return;
            this.scrollToLook(this.looks.indexOf(look), false);
          };

          this.track.addEventListener('scroll', this.handleScroll, { passive: true });
          window.addEventListener('resize', this.handleResize, { passive: true });
          document.addEventListener('shopify:block:select', this.handleBlockSelect);

          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
          this.track.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.step(1);
            } else if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.step(-1);
            }
          });
          this.looks.forEach((look, i) => {
            look.addEventListener('mouseenter', () => {
              this.hovered = i;
              this.render();
            });
            look.addEventListener('mouseleave', () => {
              this.hovered = null;
              this.render();
            });
          });

          this.setupDrag();
          if (this.dataset.wheel === 'true') this.setupWheel();
          this.setOffsets();
          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.handleResize);
          document.removeEventListener('shopify:block:select', this.handleBlockSelect);
          if (this.cleanupDrag) this.cleanupDrag();
        }

        setOffsets() {
          if (this.classList.contains('runway--overlay-header')) {
            const header = document.querySelector('.section-header');
            let pull = 0;
            if (header) {
              pull = header.getBoundingClientRect().height + (parseFloat(getComputedStyle(header).marginBottom) || 0);
            }
            this.style.setProperty('--runway-pull', pull + 'px');
          }
          const top = this.getBoundingClientRect().top + window.scrollY;
          const offset = top > 0 && top < window.innerHeight * 0.4 ? top : 0;
          this.style.setProperty('--runway-top', offset + 'px');
        }

        edgeOffset() {
          return parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        }

        activeIndex() {
          const trackRect = this.track.getBoundingClientRect();
          const mobile = this.mqMobile.matches;
          const anchor = mobile ? trackRect.left + trackRect.width / 2 : trackRect.left + this.edgeOffset();
          let best = 0;
          let bestDistance = Infinity;
          this.looks.forEach((look, i) => {
            const rect = look.getBoundingClientRect();
            const point = mobile ? rect.left + rect.width / 2 : rect.left;
            const distance = Math.abs(point - anchor);
            if (distance < bestDistance) {
              bestDistance = distance;
              best = i;
            }
          });
          return best;
        }

        update() {
          if (!this.looks.length) return;
          this.index = this.activeIndex();
          const max = this.track.scrollWidth - this.track.clientWidth;
          if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 2;
          if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= max - 2;
          this.render();
        }

        render() {
          if (!this.currentEl) return;
          const i = this.hovered !== null ? this.hovered : this.index;
          this.currentEl.textContent = String(i + 1).padStart(2, '0');
        }

        scrollToLook(i, smooth = true) {
          const look = this.looks[Math.max(0, Math.min(this.looks.length - 1, i))];
          if (!look) return;
          const trackRect = this.track.getBoundingClientRect();
          const rect = look.getBoundingClientRect();
          const left = this.mqMobile.matches
            ? this.track.scrollLeft + rect.left + rect.width / 2 - (trackRect.left + trackRect.width / 2)
            : this.track.scrollLeft + rect.left - trackRect.left - this.edgeOffset();
          this.track.scrollTo({ left, behavior: smooth && !this.reduceMotion.matches ? 'smooth' : 'auto' });
        }

        step(direction) {
          this.scrollToLook(this.index + direction);
        }

        setupDrag() {
          if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          let startX = 0;
          let startLeft = 0;
          let pointerDown = false;
          let dragging = false;

          const onDown = (event) => {
            if (event.pointerType !== 'mouse' || event.button !== 0) return;
            pointerDown = true;
            dragging = false;
            startX = event.clientX;
            startLeft = this.track.scrollLeft;
          };
          const onMove = (event) => {
            if (!pointerDown) return;
            const dx = event.clientX - startX;
            if (!dragging && Math.abs(dx) > 6) {
              dragging = true;
              this.track.classList.add('is-dragging', 'is-free');
            }
            if (dragging) {
              event.preventDefault();
              this.track.scrollLeft = startLeft - dx;
            }
          };
          const onUp = () => {
            if (!pointerDown) return;
            pointerDown = false;
            if (!dragging) return;
            dragging = false;
            this.suppressClick = true;
            setTimeout(() => {
              this.suppressClick = false;
            }, 0);
            this.track.classList.remove('is-dragging');
            this.update();
            this.scrollToLook(this.index);
            setTimeout(() => this.track.classList.remove('is-free'), 500);
          };
          const onClick = (event) => {
            if (this.suppressClick) {
              event.preventDefault();
              event.stopPropagation();
            }
          };
          const onDragStart = (event) => event.preventDefault();

          this.track.addEventListener('pointerdown', onDown);
          window.addEventListener('pointermove', onMove);
          window.addEventListener('pointerup', onUp);
          window.addEventListener('pointercancel', onUp);
          this.track.addEventListener('click', onClick, true);
          this.track.addEventListener('dragstart', onDragStart);

          this.cleanupDrag = () => {
            window.removeEventListener('pointermove', onMove);
            window.removeEventListener('pointerup', onUp);
            window.removeEventListener('pointercancel', onUp);
          };
        }

        setupWheel() {
          let idle;
          this.track.addEventListener(
            'wheel',
            (event) => {
              if (event.ctrlKey || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
              const max = this.track.scrollWidth - this.track.clientWidth;
              if (max <= 0) return;
              const left = this.track.scrollLeft;
              if ((event.deltaY < 0 && left <= 0) || (event.deltaY > 0 && left >= max - 1)) return;
              event.preventDefault();
              this.track.classList.add('is-free');
              const delta = event.deltaMode === 1 ? event.deltaY * 16 : event.deltaY;
              this.track.scrollLeft = left + delta;
              clearTimeout(idle);
              idle = setTimeout(() => this.track.classList.remove('is-free'), 200);
            },
            { passive: false }
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
